module.exports = "/_next/static/images/lock_active-b68b5ff17c4d06343f99bd0916ee6954.svg";